import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/audlog/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/audlog/';

class AuditLogService {

  getAll(initiatorName, page, pageSize) {
    return axios.get(API_URL + `all?initiatorName=${initiatorName}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `one/${id}`, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }


  getAuditLogsByDate(startDate, endDate, page, pageSize) {
    return axios.get(API_URL + `trandaterange/${startDate}/${endDate}/${page}/${pageSize}`, { headers: authHeader() });
  }
  
}

export default new AuditLogService();